import React from "react";
import URLs from "constants/urls";
import ProviderBusiness from "../Reports/providerBusiness";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

export default function ProviderWiseBusiness() {
  return (
    <DashboardLayout>
      <ProviderBusiness
        providerWiseBusinesByDateRange={URLs.providerWiseBusinesByDateRange}
        providerWiseBusinessEntriesURL={URLs.providerWiseBusinessEntriesURL}
      />
    </DashboardLayout>
  );
}
